module.exports = __webpack_public_path__ + "static/media/icon-play.780458ce.svg";